import { forwardRef, Ref } from 'react';
import Link from 'next/link';

import { parseContent } from '~/utils';

type ALinkProps = {
  scroll?: boolean;
  role?: string;
  id?: string;
  title?: string;
  className?: string;
  content?: string;
  href: string | any;
  // Máscara de URL del Pages Router (p. ej. /award/12 con query oculta).
  as?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick' | 'content'>;

const ALink = forwardRef(
  (
    { children, className, content, style, onClick, href, ...props }: ALinkProps,
    ref: Ref<HTMLAnchorElement>,
  ) => {
    const preventDefault = (e) => {
      if (href === '#') {
        e.preventDefault();
      }

      if (onClick) {
        onClick();
      }
    };

    return content ? (
      <Link
        {...props}
        ref={ref}
        href={href}
        className={className}
        style={style}
        onClick={preventDefault}
        dangerouslySetInnerHTML={parseContent(content)}
      />
    ) : (
      <Link
        {...props}
        ref={ref}
        href={href}
        className={className}
        style={style}
        onClick={preventDefault}
      >
        {children}
      </Link>
    );
  },
);

ALink.displayName = 'ALink';

export default ALink;
